import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Tournaments from "@/pages/Tournaments";
import TournamentDetail from "@/pages/TournamentDetail";
import Teams from "@/pages/Teams";
import Leaderboard from "@/pages/Leaderboard";
import Manifesto from "@/pages/Manifesto";
import Roadmap from "@/pages/Roadmap";
import ChampionWall from "@/pages/ChampionWall";
import Rules from "@/pages/Rules";
import Live from "@/pages/Live";
import TestBracket from "@/pages/TestBracket";
import PlayerProfile from "@/pages/PlayerProfile";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AuthCallback from "@/pages/AuthCallback";
import AdminDashboard from "@/pages/AdminDashboard";
import { Login, Register } from "@/pages/Auth";

function App() {
    return (
        <div className="min-h-screen bg-void text-white noise">
            <BrowserRouter>
                <AuthProvider>
                    <SmoothScroll>
                        <Header />
                        <main>
                            <Routes>
                                <Route path="/" element={<Landing />} />
                                <Route path="/tournaments" element={<Tournaments />} />
                                <Route path="/tournaments/:slug" element={<TournamentDetail />} />
                                <Route path="/teams" element={<Teams />} />
                                <Route path="/leaderboard" element={<Leaderboard />} />
                                <Route path="/manifesto" element={<Manifesto />} />
                                <Route path="/roadmap" element={<Roadmap />} />
                                <Route path="/champions" element={<ChampionWall />} />
                                <Route path="/rules" element={<Rules />} />
                                <Route path="/live" element={<Live />} />
                                <Route path="/bracket/:slug" element={<TestBracket />} />
                                <Route path="/player/:tag" element={<PlayerProfile />} />
                                <Route path="/auth/callback" element={<AuthCallback />} />
                                <Route path="/payment/success" element={<PaymentSuccess />} />
                                <Route path="/payment/cancel" element={<PaymentCancel />} />
                                <Route path="/admin" element={<AdminDashboard />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/register" element={<Register />} />
                            </Routes>
                        </main>
                        <Footer />
                    </SmoothScroll>
                </AuthProvider>
            </BrowserRouter>
            <Toaster position="bottom-right" theme="dark" toastOptions={{
                style: { background: "#0A0A0A", border: "1px solid rgba(255,255,255,0.12)", color: "#fff", borderRadius: "0", fontFamily: "Outfit, sans-serif" }
            }} />
        </div>
    );
}

export default App;
